
export const INCREAMENT= "INCREAMENT"
export const DECREAMENT= "DECREAMENT"
export const RESET= "RESET"
export const INCREAMENT_BY_VALUE= "INCREAMENT_BY_VALUE"




